import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, rolPermitido }) {
  const { rol } = useAuth();

  if (rol !== rolPermitido) {
    return <Navigate to="/" replace />;
  }

  return children;
}